import { MDXLayout } from "@/shared/components/MDX/MDXLayout";
import Content from "../../help/bom-families.mdx";

export function BomFamiliesHelpPage() {
  return (
    <MDXLayout>
      <Content />
    </MDXLayout>
  );
}
